import usePromotionCodeForm from "@insite/client-framework/Common/Hooks/usePromotionCodeForm";
import { SpreedlyIframeStyles, useSpreedlyFrame } from "@insite/client-framework/Common/Hooks/useSpreedlyFrame";
import { IFrame, TokenExIframeStyles, useTokenExFrame } from "@insite/client-framework/Common/Hooks/useTokenExFrame";
import StyledWrapper, { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper";
import { isNonEmptyString } from "@insite/client-framework/Common/Utilities/StringUtilities";
import { Cart } from "@insite/client-framework/Services/CartService";
import { FulfillmentMethod } from "@insite/client-framework/Services/SessionService";
import { TokenExConfig } from "@insite/client-framework/Services/SettingsService";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import setAddressBookOverlayIsOpen from "@insite/client-framework/Store/Components/AddressBookOverlay/Handlers/SetAddressBookOverlayIsOpen";
import {
    getCurrentUserIsGuest,
    getSession,
    getSettingsCollection,
} from "@insite/client-framework/Store/Context/ContextSelectors";
import loadSpreedlyConfig from "@insite/client-framework/Store/Context/Handlers/LoadSpreedlyConfig";
import loadTokenExConfig from "@insite/client-framework/Store/Context/Handlers/LoadTokenExConfig";
import signOut from "@insite/client-framework/Store/Context/Handlers/SignOut";
import { getBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import {
    canApplyPromotionsToCart,
    canPlaceOrder,
    getCartState,
    getCurrentCartState,
} from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import resetCurrentCartId from "@insite/client-framework/Store/Data/Carts/Handlers/ResetCurrentCartId";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import {
    getCurrentPromotionsDataView,
    getPromotionsDataView,
} from "@insite/client-framework/Store/Data/Promotions/PromotionsSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import applyPromotion from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/ApplyPromotion";
import removePromotion from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/RemovePromotion";
import placeOrder from "@insite/client-framework/Store/Pages/OnePageCheckout/Handlers/PlaceOrder";
import setIsPlacingOrder from "@insite/client-framework/Store/Pages/OnePageCheckout/Handlers/SetIsPlacingOrder";
//import setOnePageCheckoutPaymentMethod from "@insite/client-framework/Store/Pages/OnePageCheckout/Handlers/SetOnePageCheckoutPaymentMethod";
import setOnePageCheckoutPaymentMethod from "@sunSource/Store/Data/NewOnePageCheckout/Handlers/SetOnePageCheckoutPaymentMethod";
import setPaymentDetailsState from "@insite/client-framework/Store/Pages/OnePageCheckout/Handlers/SetPaymentDetailsState";
import preloadOrderConfirmationData from "@insite/client-framework/Store/Pages/OrderConfirmation/Handlers/PreloadOrderConfirmationData";
import translate from "@insite/client-framework/Translate";
import { BrandModel, PaymentMethodDto, PromotionModel } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import AddressInfoDisplay, { AddressInfoDisplayStyles } from "@insite/content-library/Components/AddressInfoDisplay";
import usePaymentDetailsCartState from "@insite/content-library/Hooks/Payments/usePaymentDetailsCartState";
//import usePaymentDetailsFormHandlers from "@insite/content-library/Hooks/Payments/usePaymentDetailsFormHandlers";
import usePaymentDetailsFormHandlers from "@sunSource/Store/Data/NewOnePageCheckout/Carts/Handlers/usePaymentDetailsFormHandlers";
import usePaymentDetailsFormState from "@insite/content-library/Hooks/Payments/usePaymentDetailsFormState";
import usePaymentDetailsFormValidation from "@insite/content-library/Hooks/Payments/usePaymentDetailsFormValidation";
// import CreditCardDetailsEntry, {
//     CreditCardDetailsEntryStyles,
//     CreditCardDetailsValidation,
// } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CreditCardDetailsEntry";
import CreditCardDetailsEntryComponent, {
    CreditCardDetailsEntryStyles,
    CreditCardDetailsValidation,
} from "@sunSource/Widgets/NewOnePageCheckout/CreditCardDetailsEntryComponent";

import ECheckDetailsEntry, {
    ECheckDetailsEntryStyles,
    Validatable,
} from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/ECheckDetailsEntry";
import PaymentProfileBillingAddress from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/PaymentProfileBillingAddress";
import SavedPaymentProfileEntry, {
    SavedPaymentProfileEntryStyles,
    SavedPaymentProfileValidation,
} from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/SavedPaymentProfileEntry";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Checkbox from "@insite/mobius/Checkbox";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import LoadingOverlay from "@insite/mobius/LoadingOverlay";
import Select, { SelectPresentationProps } from "@insite/mobius/Select";
import { generateSpreedlyFrameStyleConfig } from "@insite/mobius/SpreedlyFrame";
import Tag, { TagPresentationProps } from "@insite/mobius/Tag";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import ToasterContext, { HasToasterContext, withToaster } from "@insite/mobius/Toast/ToasterContext";
import { generateTokenExFrameStyleConfig } from "@insite/mobius/TokenExFrame";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import { addShippingInfoDataLayer } from "@sunSource/Components/AddToShippingInfoDataLayer";
import CustomApplicationState from "@sunSource/Store/CustomApplicationState";
//import CheckoutCustomTaxExemptStatusHandler from "@sunSource/Store/Data/CheckoutCustomTaxExemptStatus/Handler/CheckoutCustomTaxExemptStatusHandler";
import CheckoutCustomTaxExemptStatusHandler from "@sunSource/Store/Data/NewOnePageCheckout/Handlers/CheckoutCustomTaxExemptStatusHandler";
import OnePageCheckoutCustomNotesHandler from "@sunSource/Store/Data/OnePageCheckoutCustomNotes/Handler/OnePageCheckoutCustomNotes";
import React, { useEffect, useRef, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import styled, { css, ThemeProps, withTheme } from "styled-components";
import { set } from "js-cookie";
import Icon from "@insite/mobius/Icon";
import VisaCard from "@sunSource/Icons/VisaCard";
import MasterCard from "@sunSource/Icons/MasterCard";
import DiscoverCard from "@sunSource/Icons/DiscoverCard";
import AmexCard from "@sunSource/Icons/AmexCard";
import DefaultCard from "@sunSource/Icons/DefaultCard";
import BillToSelectorModal, { BillToSelectorModalStyles } from "@insite/content-library/Widgets/OnePageCheckout/BillToSelectorModal";

const mapStateToProps = (state: ApplicationState & CustomApplicationState) => {
    const { cartId, isPlacingOrder, paymentDetailsState, placeOrderErrorMessage } = state.pages.onePageCheckout;
    const cartState = cartId ? getCartState(state, cartId) : getCurrentCartState(state);
    const {
        websiteSettings,
        productSettings: { enableVat },
        cartSettings: { bypassCvvForSavedCards },
    } = getSettingsCollection(state);
    const cart = getCurrentCartState(state).value;
    const promotionsDataView = cartId ? getPromotionsDataView(state, cartId) : getCurrentPromotionsDataView(state);
    const promotions = promotionsDataView.value;
    return {
        cartState,
        websiteSettings,
        tokenExConfigs: state.context.tokenExConfigs,
        savedPaymentsPageLink: getPageLinkByPageType(state, "SavedPaymentsPage"),
        session: state.context.session,
        signInPageLink: getPageLinkByPageType(state, "SignInPage"),
        location: getLocation(state),
        enableVat,
        bypassCvvForSavedCards,
        isPlacingOrder,
        paymentDetailsState,
        placeOrderErrorMessage,
        confirmationPageLink: getPageLinkByPageType(state, "OnePageCheckoutConfirmationPage"),
        billToState: getBillToState(state, cart?.billToId),
        fulfillmentMethod: getSession(state).fulfillmentMethod,
        currentUserIsGuest: getCurrentUserIsGuest(state),
        canApplyPromosToCart: canApplyPromotionsToCart(cartState?.value),
        promotionErrorMessage: state.pages.checkoutReviewAndSubmit.promotionErrorMessage,
        promotions,
        canPlaceOrder: canPlaceOrder(cartState.value),
        spreedlyConfig: state.context.spreedlyConfig,
        taxExemptStatus: state?.sunSourceState?.CheckoutCustomTaxExemptStatus.taxExemptStatus,
        onePageCheckout: state.pages.onePageCheckout
    };
};

const mapDispatchToProps = {
    loadTokenExConfig,
    preloadOrderConfirmationData,
    resetCurrentCartId,
    setOnePageCheckoutPaymentMethod,
    signOut,
    setPaymentDetailsState,
    placeOrder,
    setIsPlacingOrder,
    OnePageCheckoutCustomNotesHandler,
    applyPromotion,
    removePromotion,
    loadSpreedlyConfig,
    CheckoutCustomTaxExemptStatusHandler,
    setAddressBookOverlayIsOpen
};

type DataLayerCartItem = {
    item_category: string;
    item_id: string;
    item_name: string;
    index: number;
    item_brand: string | BrandModel;
    price: number | string | undefined;
    quantity: number | string | undefined;
    item_list_id?: string;
    item_list_name?: string;
    [key: string]: any;
};

type Props = ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    ThemeProps<BaseTheme> &
    HasHistory &
    HasToasterContext;

export interface OnePageCheckoutPaymentDetailsStyles {
    form?: InjectableCss;
    fieldset?: InjectableCss;
    paymentDetailsGridContainer?: GridContainerProps;
    paymentDetailsHeadingGridItem?: GridItemProps;
    paymentDetailsHeadingText?: TypographyPresentationProps;
    paymentdMethodInfoGridItem?: GridItemProps;
    paymentdMethodInfoGridItemActive?: GridItemProps;
    paymentdMethodInfoGridItemWrapper?: GridItemProps;
    billingAddressInfoGridItem?: GridItemProps;
    paymentdMethodNameText?: TypographyPresentationProps;
    paymentdMethodCreditCardInfoText?: TypographyPresentationProps;
    editGridItem?: GridItemProps;
    editLink?: LinkPresentationProps;
    paymentMethodAndPONumberContainer?: GridContainerProps;
    paymentMethodGridItem?: GridItemProps;
    paymentMethodSelect?: SelectPresentationProps;
    paymentProfileBillingAddress?: any;
    paymentProfileExpiredErrorWrapper?: InjectableCss;
    paymentProfileExpiredErrorText?: TypographyPresentationProps;
    paymentProfileEditCardLink?: LinkPresentationProps;
    vatNumberGridItem?: GridItemProps;
    vatNumberText?: TextFieldPresentationProps;
    savedCards?: GridItemProps;
    poNumberGridItem?: GridItemProps;
    poNumberText?: TextFieldPresentationProps;
    emptyGridItem?: GridItemProps;
    adyenDropInGridItem?: GridItemProps;
    mainContainer?: GridContainerProps;
    savedPaymentProfile?: SavedPaymentProfileEntryStyles;
    creditCardDetailsGridItem?: GridItemProps;
    eCheckDetailsGridItem?: GridItemProps;
    creditCardDetails?: CreditCardDetailsEntryStyles;
    creditCardAddressGridItem?: GridItemProps;
    eCheckDetailsEntryStyles?: ECheckDetailsEntryStyles;
    saveAndContinueButtonGridItem: GridItemProps;
    saveAndContinueButton?: ButtonPresentationProps;
    saveCardCheckboxGridItem: GridItemProps;
    headingGridItem?: GridItemProps;
    heading?: TypographyPresentationProps;
    billToGridItem?: GridItemProps;
    addressInfoDisplay?: AddressInfoDisplayStyles;
    promotionsCodeGridItem?: GridItemProps;
    promotionTagsGridContainerItem?: GridItemProps;
    promotionTagsGridContainer?: GridContainerProps;
    promotionCodeGridContainer?: GridContainerProps;
    promotionTagsGridItem?: GridItemProps;
    promotionCodeTag?: TagPresentationProps;
    promotionCodeTagName?: TypographyPresentationProps;
    addDiscountGridItem?: GridItemProps;
    addDiscountButton?: ButtonPresentationProps;
    enterPromotionCodeGridItem?: GridItemProps;
    enterPromotionCodeTextField?: TextFieldPresentationProps;
    enterPromotionCodeApplyButton?: ButtonPresentationProps;
    appliedPromoCodeOverviewText?: TypographyPresentationProps;
    discountLabel?: TypographyPresentationProps;
    taxExemptGridItem?: GridItemProps;
    taxExemptDescription?: InjectableCss;
    radioInputWrapper?: InjectableCss;
    inputHeader?: InjectableCss;
    cardIcons?: InjectableCss;
    secondaryText?: InjectableCss;
    shipToGridItem?: GridItemProps;
    changeLabel?: InjectableCss;
    companyDetailsGridItem?: GridItemProps;
    companyDetailsWrapper?: InjectableCss;
    billToSelectorModal?: BillToSelectorModalStyles;
    companyName?: InjectableCss;
    
}

export const onePageCheckoutPaymentDetailsStyles: OnePageCheckoutPaymentDetailsStyles = {
    fieldset: {
        css: css`
            margin: 0;
            padding: 0;
            border: 0;
        `,
    },
    paymentDetailsGridContainer: { gap: 20 },
    paymentDetailsHeadingGridItem: {
        width: 10,
        css: css`
            align-items: center;
        `,
    },
    paymentDetailsHeadingText: {
        variant: "h5",
        css: css`
            margin-bottom: 0;
        `,
    },
    paymentdMethodInfoGridItem: {
        width: [12,12,6,6,6],
        css: css`
            flex-direction: column;
        `,
    },
    paymentdMethodInfoGridItemActive:{
        width: 12,
        css:css`
            flex-direction: column;
        `
    },
    paymentdMethodInfoGridItemWrapper: {
        width: 12,
        css: css`
            flex-direction: row;
            padding-top: 25px;
        `,
    },
    editGridItem: {
        width: 2,
        css: css`
            justify-content: end;
            align-items: center;
        `,
    },
    paymentMethodAndPONumberContainer: {
        gap: 10,
        css: css`
            margin-bottom: 8px;
        `,
    },
    paymentMethodGridItem: {
        width: 6,
        css: css`
            padding: 0px;
            flex-direction: column;
        `,
    },
    paymentProfileExpiredErrorWrapper: {
        css: css`
            display: flex;
            width: 100%;
        `,
    },
    paymentProfileExpiredErrorText: { color: "danger" },
    paymentProfileEditCardLink: {
        css: css`
            margin-left: 1rem;
        `,
    },
    vatNumberGridItem: { width: 6, css: css`
        margin: 10px 0px !important;
         ` },
    savedCards: { width: 6, css: css`
        margin: 10px 0px !important;
         ` },
    poNumberGridItem: { width: 6, css: css`
        margin: 10px 0px !important;
         ` },
    emptyGridItem: { width: 6 },
    creditCardDetailsGridItem: { width: 12 },
    eCheckDetailsGridItem: { width: [12, 12, 12, 6, 6] },
    creditCardAddressGridItem: {
        width: [12, 12, 12, 6, 6],
        css: css`
            flex-direction: column;
        `,
    },
    adyenDropInGridItem: { width: 12 },
    saveAndContinueButtonGridItem: {
        width: 12,
        css: css`
        justify-content: right;
        `
    },
    saveAndContinueButton: {
        
        variant: "tertiary",
        css: css`
            margin-top: 1em;
            width: 140px;
            text-transform: uppercase;
            font-weight: 400;
        `,
    },
    saveCardCheckboxGridItem: {
        width: 12,
    },
    headingGridItem: {
        width: 12,
        css: css`
            justify-content: space-between;
            padding: 15px 5px 5px 5px;
        `,
    },
    heading: { weight: 600 },
    billToGridItem: { width: 12, css: css`
        padding:0px;
        padding-top: 5px;
        ` },
    promotionsCodeGridItem: {
        width: 12,
    },
    promotionCodeGridContainer: {
        gap: 10,
    },
    promotionTagsGridContainer: {
        gap: 2,
    },
    promotionTagsGridContainerItem: {
        width: 12,
    },
    promotionTagsGridItem: {
        width: 12,
    },
    addDiscountGridItem: {
        width: 12,
    },
    addDiscountButton: {
        variant: "secondary",
    },
    enterPromotionCodeGridItem: {
        width: 6,
    },
    enterPromotionCodeApplyButton: {
        variant: "secondary",
    },
    promotionCodeTag: {
        css: css`
            & > button {
                min-height: 0;
            }
        `,
    },
    promotionCodeTagName: {
        css: css`
            align-self: flex-end;
            padding-bottom: 15px;
        `,
    },
    appliedPromoCodeOverviewText: {
        css: css`
            padding-bottom: 15px;
        `,
    },
    taxExemptDescription: {
        css: css`
            font-size: 12px;
        `
    },
    taxExemptGridItem: {
        width: [12, 12, 12, 12, 12],
    },
    radioInputWrapper:{
            css: css`
                input{
                margin-top:0px;
                }
    
                 display: flex;
        align-items: center;
    
        input[type="radio"] {
            display: none; /* Hide default radio button */
        }
    
            `
        },
        inputHeader: {
            css: css`
            color: dimgray;
            margin-bottom: 15px;
            margin-top: 10px;
            display: block;
            font-size: 18px;
            `
        },
        cardIcons:{
            css:css`
                height: 22px;
                width: 35px;
                border: 2px solid #dcdcdc;
                border-radius: 4px;
                margin-right: 5px;
                background: #ffffff;
                display: flex;
                justify-content: center;
                align-items: center;
                svg{
                    height: 30px;
                    width: 30px;
                }
            `
        },
        paymentdMethodCreditCardInfoText:{
            css:css`
            display: flex;
            align-items: center;
            font-size:16px;
            font-weight: 600;
            `
        },
        secondaryText:{
            css: css`
            color: gray;
            padding-left: 40px;
        `,
        },
        billingAddressInfoGridItem: { width: [12,12,6,6,6], css:css`
        padding: 0px;
        padding-top: 5px;
        [data-test-selector="addressInfoDisplay_companyName"]{
        font-weight:600;
        }
        p{
            color: gray;
            text-transform: capitalize;
        }
        ` },
        changeLabel: {
                css: css`
                    color: #00539b;
                    font-weight: 600;
                    cursor: pointer;
                `,
            },
            companyDetailsGridItem: {
                width: 12,
                css: css`
                    padding-top: 0px;
                `,
            },
            companyName: {
                    css: css`
                        font-weight: 600;
                    `,
                },
                companyDetailsWrapper: {
                        css: css`
                            display: flex;
                            flex-direction: column;
                        `,
                    },
};

let tokenExAccountNumberIframe: IFrame | undefined;
let tokenExFrameStyleConfig: TokenExIframeStyles;
let spreedlyFrameStyleConfig: SpreedlyIframeStyles;

const styles = onePageCheckoutPaymentDetailsStyles;
const StyledForm = getStyledWrapper("form");
const StyledFieldSet = getStyledWrapper("fieldset");

const CustomRadio = styled.div`
display: flex;
align-items: center;
margin-bottom: 8px;

input[type="radio"] {
    display: none; /* Hide default radio button */
}

label {
    position: relative;
    padding-left: 30px;
    cursor: pointer;
    font-size: 14px;
    color: #333;
    font-weight: 600;
}

label::before {
    content: "";
    position: absolute;
    left: 0;
    top: 0px;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 1px solid #D3D3D3;
    background-color: white;
    transition: all 0.3s;
}

input[type="radio"]:checked + label::before {
    border-color: #D3D3D3;
background: white;
}

label::after {
    content: "";
    position: absolute;
    left: 4px;
    top: 4px;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: #00539B;
    opacity: 0;
    transition: opacity 0.3s;
}

input[type="radio"]:checked + label::after {
    opacity: 1;
}
`;

const OnePageCheckoutPaymentDetails = ({
    cartState,
    tokenExConfigs,
    savedPaymentsPageLink,
    history,
    loadTokenExConfig,
    loadSpreedlyConfig,
    theme,
    enableVat,
    bypassCvvForSavedCards,
    setOnePageCheckoutPaymentMethod,
    isPlacingOrder,
    paymentDetailsState,
    placeOrderErrorMessage,
    signInPageLink,
    setPaymentDetailsState,
    placeOrder,
    setIsPlacingOrder,
    confirmationPageLink,
    billToState,
    fulfillmentMethod,
    currentUserIsGuest,
    OnePageCheckoutCustomNotesHandler,
    canApplyPromosToCart,
    applyPromotion,
    promotionErrorMessage,
    promotions,
    removePromotion,
    canPlaceOrder,
    spreedlyConfig,
    taxExemptStatus,
    onePageCheckout,
    session,
    CheckoutCustomTaxExemptStatusHandler,
    setAddressBookOverlayIsOpen
}: Props) => {
    const taxExemptStatusRef = useRef<HTMLInputElement>(null);
    const [taxExemptStatusError, setTaxExemptStatusError] = useState("");
    const paymentDetailsFormState = usePaymentDetailsFormState();
    const currencyCode = session.currency?.currencyCode;
    const {
        paymentMethod,
        setPaymentMethod,
        poNumber,
        vatNumber,
        saveCard,
        cardHolderName,
        cardNumber,
        cardType,
        expirationMonth,
        expirationYear,
        securityCode,
        countryId,
        paymentMethodError,
        poNumberError,
        showFormErrors,
        setShowFormErrors,
        isCardNumberTokenized,
        setIsCardNumberTokenized,
        isECheckTokenized,
        setIsECheckTokenized,
        accountHolderName,
        setAccountHolderName,
        accountNumber,
        setAccountNumber,
        routingNumber,
        setRoutingNumber,
        creditCardLastFourDigits,
        bankAccountLastFourDigits,
        isIframeLoaded,
        paymentMethodRef,
        poNumberRef,
        maskedCardNumber,
        setMaskedCardNumber,
    } = paymentDetailsFormState;
    const paymentDetailsCartState = usePaymentDetailsCartState(cartState, paymentMethod, countryId);
    const {
        cart,
        useTokenExGateway,
        useECheckTokenExGateway,
        paymentOptions,
        paymentMethods,
        paymentMethodDto,
        isCreditCard,
        isECheck,
        isPaymentProfile,
        useSpreedlyDropIn,
    } = paymentDetailsCartState;
    const paymentDetailsFormValidation = usePaymentDetailsFormValidation(
        paymentDetailsFormState,
        paymentDetailsCartState,
    );
    const { validatePaymentMethod, validatePONumber } = paymentDetailsFormValidation;
    const {
        handlePaymentMethodChange,
        handlePONumberChange,
        handleVatNumberChange,
        handleSaveCardChange,
        handleCardHolderNameChange,
        handleCardNumberChange,
        handleCardTypeChange,
        handleExpirationMonthChange,
        handleExpirationYearChange,
        handleSecurityCodeChange,
        handleEditCardClick,
    } = usePaymentDetailsFormHandlers({
        paymentDetailsFormState,
        paymentDetailsFormValidation,
        paymentDetailsCartState,
        history,
        savedPaymentsPageLink,
        setPaymentMethodCallback: (
            event: React.ChangeEvent<HTMLSelectElement>,
            paymentMethods: PaymentMethodDto[] | null | undefined,
        ) => {
            setOnePageCheckoutPaymentMethod({
                paymentMethod: paymentMethods?.find(method => method.name === event.target.value),
            });
        },
    });
    const tokenExLibraryIsLoaded = useTokenExFrame();
    const spreedlyLibraryIsLoaded = useSpreedlyFrame();
    const {
        promotionCode,
        setPromotionCode,
        promotionsWithCode,
        setRemovingPromotionCode,
        isAddingDiscount,
        setIsAddingDiscount,
        isUpdatingPromotions,
        setIsUpdatingPromotions,
    } = usePromotionCodeForm(promotions);

    const applyPromotionHandler = () => {
        setIsUpdatingPromotions(true);
        applyPromotion({
            promotionCode: promotionCode.trim(),
            onComplete: (
                result: Partial<{
                    successMessage: string;
                    errorMessage: string;
                    isPromotionAppliedSuccess: boolean;
                }>,
            ) => {
                if (result.isPromotionAppliedSuccess) {
                    setPromotionCode("");
                    setIsAddingDiscount(false);
                }
                setIsUpdatingPromotions(false);
            },
        });
    };

    const removePromotionHandler = (promotion: PromotionModel) => {
        setIsUpdatingPromotions(true);
        removePromotion({
            promotionId: promotion.id,
            onComplete: () => {
                setIsUpdatingPromotions(false);
            },
        });
        setRemovingPromotionCode(promotion.promotionCode);
    };

    const billTo = billToState.value;
 
    useEffect(() => {
        if (!isPlacingOrder || !canPlaceOrder) {
            return;
        }
        addToDataLayer(cartState.value, paymentMethod ?? paymentMethodDto?.name);
        placeOrder({
            paymentMethod,
            poNumber,
            vatNumber,
            saveCard,
            cardHolderName,
            cardNumber,
            cardType,
            expirationMonth,
            expirationYear,
            securityCode,
            useBillingAddress: true,
            address1: "",
            countryId: "",
            stateId: "",
            city: "",
            postalCode: "",
            accountHolderName,
            accountNumber,
            routingNumber,
            payerId: "",
            maskedCardNumber,
            onSuccess: (cartId: string) => {
                setIsPlacingOrder({ isPlacingOrder: false });
                
                if (!confirmationPageLink) {
                    return;
                }

                history.push(`${confirmationPageLink.url}?cartId=${cartId}`);
            },
            onError: () => {
                setIsCardNumberTokenized(false);
                setIsPlacingOrder({ isPlacingOrder: false });
            },
            onComplete(resultProps) {
                if (resultProps.apiResult?.cart) {
                    // "this" is targeting the object being created, not the parent SFC
                    // eslint-disable-next-line react/no-this-in-sfc
                    this.onSuccess?.(resultProps.apiResult.cart.id);
                } else {
                    // "this" is targeting the object being created, not the parent SFC
                    // eslint-disable-next-line react/no-this-in-sfc
                    this.onError?.();
                }
            },
        });
    }, [isPlacingOrder]);


    useEffect(() => {
        if (isCardNumberTokenized || isECheckTokenized) {
            setPaymentDetailsState({ paymentDetailsState: "complete" });
        }
    }, [isCardNumberTokenized, isECheckTokenized]);

    useEffect(() => {
        if (!cartState.isLoading && cartState.value && cartState.value.paymentMethod && paymentMethod === "") {
            setPaymentMethod(cartState.value.paymentMethod.name);
        }
    }, [cartState]);

    useEffect(() => {
        setPaymentMethod("");
        setPaymentDetailsState({ paymentDetailsState: "active" });
        if (cart) {
            if (cart.cartLines && cart.carrier && cart.carrier.description) {
                addShippingInfoDataLayer(cart.cartLines, cart.carrier.description, cartState?.value?.orderGrandTotal ?? "", currencyCode);
            }
        }
    }, []);

    let tokenName: string | undefined;
    const eCheckDetails = useRef<Validatable>(null);
    const creditCardDetails = useRef<CreditCardDetailsValidation>(null);
    const savedPaymentProfile = useRef<SavedPaymentProfileValidation>(null);

    if (useTokenExGateway) {
        if (isPaymentProfile) {
            tokenName = paymentMethodDto!.name;
        } else if (isCreditCard) {
            tokenName = "";
        }
    }

    if (useECheckTokenExGateway) {
        if (isECheck) {
            tokenName = "";
        }
    }

    useEffect(() => {
        if (typeof tokenName !== "undefined") {
            loadTokenExConfig({ token: tokenName, isECheck });
        }

        if (useSpreedlyDropIn && !spreedlyConfig?.environmentKey) {
            loadSpreedlyConfig();
        }
    }, [paymentMethod]);

    const handleTokenExSessionExpired = (token: string) => {
        loadTokenExConfig({ token, isECheck });
    };

    const tokenExConfig = typeof tokenName !== "undefined" ? tokenExConfigs[tokenName] : undefined;

    const saveCreditCardChangeHandler = (event: React.SyntheticEvent, value: boolean) => {
        handleSaveCardChange(value);
    };
    const toasterContext = React.useContext(ToasterContext);
    useEffect(() => {
        if (placeOrderErrorMessage === siteMessage("CreditCardInfo_MaximumCreditCardAttempts")) {
            toasterContext.addToast({
                body: placeOrderErrorMessage,
                messageType: "danger",
            });

            setTimeout(() => {
                signOut();
                signInPageLink && history.push(signInPageLink.url);
            }, 3000);
        }
    }, [placeOrderErrorMessage]);


    const handleAccountNumberIFrame = (accountNumberIFrame: IFrame) => {
        tokenExAccountNumberIframe = accountNumberIFrame;
    };

    const validateForm = () => {
        const paymentMethodValid = validatePaymentMethod(paymentMethod);
        const taxExemptStatusValid = isNonEmptyString(taxExemptStatus);
        setTaxExemptStatusError(!taxExemptStatusValid ? translate("Tax Exempt Status is reuqired"): "");
        const poNumberValid = validatePONumber(poNumber);

        if (useECheckTokenExGateway && isECheck) {
            tokenExAccountNumberIframe?.validate();
        }

        let accountHolderNameValid = true;
        let accountNumberValid = true;
        let routingNumberValid = true;
        if (eCheckDetails?.current) {
            accountHolderNameValid = eCheckDetails.current.validateAccountHolderNameChange(accountHolderName);
            accountNumberValid = eCheckDetails.current.validateAccountNumberChange(accountNumber);
            routingNumberValid = eCheckDetails.current.validateRoutingNumberChange(routingNumber);
        }
        let creditCardValid = true;
        if (creditCardDetails?.current) {
            creditCardValid = creditCardDetails.current.validate();
        }

        if (savedPaymentProfile?.current) {
            creditCardValid = savedPaymentProfile?.current.validate();
        }
        if (!paymentMethodValid) {
            paymentMethodRef.current?.focus();
        } else if (!poNumberValid) {
            poNumberRef.current?.focus();
        } else if(!taxExemptStatusValid) {
            taxExemptStatusRef.current?.focus()
        }

        return (
            paymentMethodValid &&
            poNumberValid &&
            creditCardValid &&
            accountHolderNameValid &&
            accountNumberValid &&
            routingNumberValid &&
            taxExemptStatusValid
        );
    };

    const handleFormSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        if (!validateForm()) {
            setShowFormErrors(true);
            return false;
        }

        if (useTokenExGateway && ((isPaymentProfile && !bypassCvvForSavedCards) || isCreditCard)) {
            creditCardDetails.current?.tokenize();
            savedPaymentProfile.current?.tokenize();
        } else if (useECheckTokenExGateway && isECheck) {
            tokenExAccountNumberIframe?.tokenize();
        } else if (useSpreedlyDropIn && isCreditCard) {
            creditCardDetails.current?.tokenize(); 
        } else {
            setPaymentDetailsState({ paymentDetailsState: "complete" });
        }

        return false;
    };

    
    const [isBillToSelectorModalOpen, setIsBillToSelectorModalOpen] = useState(false);
    const billToSelectorModalCloseHandler = () => {
        setIsBillToSelectorModalOpen(false);
    };
    const editBillingAddressClickHandler = () => {
        theme.addressBook?.useOverlay
            ? setAddressBookOverlayIsOpen({ isOpen: true, isBillTo: true })
            : setIsBillToSelectorModalOpen(true);
    };

    const handlerTaxExemptStatusChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        CheckoutCustomTaxExemptStatusHandler({ taxExemptStatus: event.target.value, checkoutType: "onepage" })
        const taxExemptStatusValid = isNonEmptyString(event.target.value);
        setTaxExemptStatusError(!taxExemptStatusValid ? translate("Tax Exempt Status is reuqired"): "");
    }

    const generateItemsList = (cartStateValue: Readonly<Cart> | undefined) => {
        const products = cartStateValue?.cartLines;
        const itemsArr: DataLayerCartItem[] = [];
        if (products && products?.length > 0) {
            products.forEach((product, index) => {
                const obj: DataLayerCartItem = {
                    item_id: product.erpNumber ?? "",
                    item_name: product.altText || "",
                    index,
                    item_brand: product.brand?.name || "",
                    price: product.pricing?.actualPrice || "",
                    quantity: product.qtyOrdered || "",
                    item_list_id: product.productId || "",
                    item_list_name: product?.properties?.categories || "",
                    item_category: product?.properties?.categories || "",
                    vendor_name: product?.properties?.vendor || siteMessage("SunSource")
                };
                const categoriesArr: string[] =
                    product && product.properties && product.properties.categories
                        ? product.properties.categories.split(",")
                        : [];

                let i = 1;
                if (categoriesArr[categoriesArr.length - 1] === "") {
                    categoriesArr.pop();
                }
                if (categoriesArr.length !== 0) {
                    const uniqueItems: Record<string, boolean> = {};
                    for (const item of categoriesArr) {
                        if (!uniqueItems[item]) {
                            if (i === 1) {
                                obj.item_category = item;
                                uniqueItems[item] = true;
                            } else {
                                // obj[`item_category${i}`] = item;
                                uniqueItems[item] = true;
                            }
                            i++;
                        }
                    }
                }
                itemsArr.push(obj);
            });
        }
        return itemsArr;
    };

    const addToDataLayer = (cartStateValue: Readonly<Cart> | undefined, paymentMethod?: string) => {
        const items = generateItemsList(cartStateValue);
        const dataLayer = (window as any).dataLayer || [];

        const currencyCode = session.currency?.currencyCode;
        const cPaymentMethod = paymentMethod || cartState.value?.paymentMethod?.description;

        if (dataLayer) {
            dataLayer.push({ ecommerce: null });
            dataLayer.push({
                event: "add_payment_info",
                ecommerce: {
                    currency: currencyCode || "",
                    payment_type: cPaymentMethod || "",
                    items,
                    value: cartStateValue?.orderGrandTotal,
                },
            });
        }
    };
    if (!tokenExFrameStyleConfig) {
        tokenExFrameStyleConfig = generateTokenExFrameStyleConfig({ theme });
    }

    if (!spreedlyFrameStyleConfig && useSpreedlyDropIn) {
        spreedlyFrameStyleConfig = generateSpreedlyFrameStyleConfig({ theme });
    }
   
    if (
        !cart ||
        cart.requiresApproval ||
        !paymentOptions ||
        (useTokenExGateway && !tokenExLibraryIsLoaded) ||
        (useSpreedlyDropIn && !spreedlyLibraryIsLoaded)
    ) {
        return null;
    }

    const iframeName = useTokenExGateway ? "TokenEx" : useSpreedlyDropIn ? "Spreedly" : undefined;

    const getCardIcon = (cardType: string) => {
        switch (cardType.toLowerCase()) {
            case "visa":
                return VisaCard;
            case "mastercard":
                return MasterCard;
            case "discover":
                return DiscoverCard;
            case "american express":
                return AmexCard;
            default:
                return DefaultCard; // Fallback to a default card icon
        }
    };

    return (
        <GridContainer {...styles.paymentDetailsGridContainer}>
            
            {paymentDetailsState === "complete" && (
                <GridItem {...styles.paymentdMethodInfoGridItemWrapper}>
                    <GridItem {...styles.paymentdMethodInfoGridItem}>
                        
                        {promotionsWithCode.length > 0 && (
                            <>
                                <Typography {...styles.discountLabel}>{translate("Discount")}:</Typography>
                                {promotionsWithCode.map(promotion => (
                                    <Typography
                                        as="p"
                                        key={`promotion-with-code-${promotion.id}`}
                                        {...styles.appliedPromoCodeOverviewText}
                                    >{`${promotion.promotionCode} ${promotion.name}`}</Typography>
                                ))}
                            </>
                        )}
                        {/* <Typography as="p" {...styles.paymentdMethodNameText} data-test-selector="paymentMethodName">
                            {paymentMethodDto?.description || paymentMethodDto?.name}
                        </Typography> */}
                        {paymentMethodDto?.isCreditCard && (
                        <Typography
                            as="p"
                            {...styles.paymentdMethodCreditCardInfoText}
                            data-test-selector="paymentMethodCreditCardInfoText"
                        >
                            <Icon  src={getCardIcon(cardType)} {...styles.cardIcons} />
                            {cardType} &nbsp;
                            {`*${cardNumber.slice(-4)}`}&nbsp;  {" "}
                            <Link
                                {...styles.editLink}
                                onClick={() => {
                                    setIsCardNumberTokenized(false);
                                    setPaymentDetailsState({
                                        paymentDetailsState: "active",
                                    });
                                }}
                            >
                                {translate(" (Change)")}
                            </Link>
                        </Typography>
                        )}
                        <Typography {...styles.secondaryText}>
                        {taxExemptStatus}
                        </Typography>
                    </GridItem>
                    <GridItem {...styles.billingAddressInfoGridItem}>
                        <GridItem {...styles.companyDetailsGridItem}>
                            <StyledWrapper {...styles.companyDetailsWrapper}>
                                <Typography {...styles.companyName}>
                                        {translate("Billing Address ")}
                                    <Typography
                                        onClick={() => {
                                            editBillingAddressClickHandler()
                                            
                                        }}
                                        {...styles.changeLabel}
                                    >
                                        {translate("(Change)")}
                                    </Typography>
                                </Typography>
                                
                                {billTo &&
                                    <GridItem {...styles.billToGridItem} data-test-selector="BillingAddress">
                                    <AddressInfoDisplay
                                        {...billTo}
                                        state={billTo.state ? billTo.state.abbreviation : undefined}
                                        country={billTo.country ? billTo.country.abbreviation : undefined}
                                        extendedStyles={styles.addressInfoDisplay}
                                    />
                                </GridItem>
                                }
                                <BillToSelectorModal
                                    isOpen={isBillToSelectorModalOpen}
                                    onModalClose={billToSelectorModalCloseHandler}
                                    extendedStyles={styles.billToSelectorModal}
                                />
                            </StyledWrapper>
                        </GridItem>
                    </GridItem>
                    
                </GridItem>
                
            )}
            

            {paymentDetailsState === "active" && (
                <GridItem {...styles.paymentdMethodInfoGridItemActive}>
                    <StyledForm
                        {...styles.form}
                        id="reviewAndSubmitPaymentForm"
                        onSubmit={handleFormSubmit}
                        noValidate={true}
                        data-test-selector="reviewAndSubmitPaymentForm"
                    >
                        <StyledFieldSet {...styles.fieldset}>
                            <GridContainer {...styles.paymentMethodAndPONumberContainer}>
                            {canApplyPromosToCart && (
                                    <LoadingOverlay loading={isUpdatingPromotions}>
                                        <GridItem {...styles.promotionsCodeGridItem}>
                                            <GridContainer {...styles.promotionCodeGridContainer}>
                                                {promotionsWithCode.length > 0 && (
                                                    <GridItem {...styles.promotionTagsGridContainerItem}>
                                                        <GridContainer {...styles.promotionTagsGridContainer}>
                                                            {promotionsWithCode.map(promotion => (
                                                                <GridItem
                                                                    key={promotion.id}
                                                                    {...styles.promotionTagsGridItem}
                                                                >
                                                                    <Tag
                                                                        onDelete={e => {
                                                                            e.preventDefault();
                                                                            removePromotionHandler(promotion);
                                                                        }}
                                                                        data-test-selector={`promotionCode_promotionTag_${promotion.promotionCode}`}
                                                                        {...styles.promotionCodeTag}
                                                                    >
                                                                        {promotion.promotionCode}
                                                                    </Tag>
                                                                    <Typography {...styles.promotionCodeTagName}>
                                                                        {promotion.name}
                                                                    </Typography>
                                                                </GridItem>
                                                            ))}
                                                        </GridContainer>
                                                    </GridItem>
                                                )}
                                                {/* {!isAddingDiscount && (
                                                    <GridItem {...styles.addDiscountGridItem}>
                                                        <Button
                                                            onClick={() => {
                                                                setIsAddingDiscount(true);
                                                            }}
                                                            {...styles.addDiscountButton}
                                                        >
                                                            {translate("Add Discount")}
                                                        </Button>
                                                    </GridItem>
                                                )} */}
                                                {isAddingDiscount && (
                                                    <>
                                                        <GridItem {...styles.enterPromotionCodeGridItem}>
                                                            <TextField
                                                                onChange={event => {
                                                                    setPromotionCode(event.target.value);
                                                                }}
                                                                onKeyDown={event => {
                                                                    if (event.keyCode === 13) {
                                                                        applyPromotionHandler();
                                                                        event.preventDefault();
                                                                    }
                                                                }}
                                                                value={promotionCode}
                                                                placeholder={translate("Enter code")}
                                                                error={promotionErrorMessage}
                                                                {...styles.enterPromotionCodeTextField}
                                                            />
                                                        </GridItem>
                                                        <GridItem {...styles.enterPromotionCodeGridItem}>
                                                            <Button
                                                                onClick={applyPromotionHandler}
                                                                disabled={!(promotionCode?.length > 0)}
                                                                {...styles.enterPromotionCodeApplyButton}
                                                            >
                                                                {translate("Apply")}
                                                            </Button>
                                                        </GridItem>
                                                    </>
                                                )}
                                            </GridContainer>
                                        </GridItem>
                                    </LoadingOverlay>
                                )}

                                <GridItem {...styles.taxExemptGridItem}>
                                    <GridContainer>
                                        <GridItem width={12}>
                                                                                    
                                            <StyledWrapper {...styles.paymentMethodSelect}>
                                                <Typography {...styles.inputHeader}>{translate("Is Your Company/Organization Tax Exempt?")}</Typography>
                                                    <CustomRadio>
                                                        <input
                                                            ref={taxExemptStatusRef}
                                                            type="radio"
                                                            id="not_tax_exempt"
                                                            name="taxExemptStatus"
                                                            value={siteMessage("not_qualify_for_tax_exempt").toString()}
                                                            checked={taxExemptStatus === siteMessage("not_qualify_for_tax_exempt").toString()}
                                                            onChange={(e) =>{ handlerTaxExemptStatusChange(e)}}
                                                            required
                                                            data-test-selector="checkoutReviewAndSubmit_tax_exempt_status"
                                                        />
                                                        <label htmlFor="not_tax_exempt">{siteMessage("not_qualify_for_tax_exempt")}</label>
                                                    </CustomRadio>

                                                    <CustomRadio>
                                                        <input
                                                            type="radio"
                                                            id="qualify_tax_exempt"
                                                            name="taxExemptStatus"
                                                            value={siteMessage("qualify_for_tax_exempt").toString()}
                                                            checked={taxExemptStatus === siteMessage("qualify_for_tax_exempt").toString()}
                                                            onChange={(e) =>{ handlerTaxExemptStatusChange(e)}}
                                                            required
                                                        />
                                                        <label htmlFor="qualify_tax_exempt">{siteMessage("qualify_for_tax_exempt")}</label>
                                                    </CustomRadio>

                                                {showFormErrors && taxExemptStatusError && <span style={{ color: "red" }}>{taxExemptStatusError}</span>}
                                            </StyledWrapper>
                                        </GridItem>
                                    </GridContainer>
                                </GridItem>
                                <GridItem width={12}>
                                    <GridItem {...styles.paymentMethodGridItem}>
                                        {paymentMethods && paymentMethods.length > 0 && (
                                            <>
                                                {/* <StyledWrapper {...styles.paymentMethodSelect}>
                                                    <Typography {...styles.inputHeader}>{translate("Payment Method *")}</Typography>
                                                    {paymentMethods.map((method) => (
                                                            <CustomRadio key={method.name}>
                                                        <input
                                                            type="radio"
                                                            id={method.name}
                                                            name="paymentMethod"
                                                            value={method.name}
                                                            checked={(paymentMethod ?? paymentMethodDto?.name) === method.name}
                                                            onChange={(e) => handlePaymentMethodChange(e)}
                                                            required
                                                        />
                                                        <label htmlFor={method.name}>{method.description}</label>
                                                    </CustomRadio>
                                                    ))}
        
                                                    {showFormErrors && paymentMethodError && <span style={{ color: "red" }}>{paymentMethodError}</span>}
                                                </StyledWrapper> */}

                                                <Select
                                                    {...styles.paymentMethodSelect}
                                                    label={translate("Payment Method ")}
                                                    value={paymentMethod ?? paymentMethodDto?.name}
                                                    onChange={(e) => handlePaymentMethodChange(e)}
                                                    required
                                                    error={showFormErrors && paymentMethodError}
                                                    data-test-selector="onePageCheckout_paymentMethod"
                                                    ref={paymentMethodRef}
                                                >
                                                    <option value="">{translate("Select Payment Method")}</option>
                                                    {paymentMethods.map(method => (
                                                        <option key={method.name} value={method.name}>
                                                            {method.description || method.name}
                                                        </option>
                                                    ))}
                                                </Select>

                                                {paymentMethodDto?.isPaymentProfile &&
                                                    !paymentMethodDto.isPaymentProfileExpired && (
                                                        <PaymentProfileBillingAddress
                                                            address={paymentMethodDto.billingAddress}
                                                            extendedStyles={styles.paymentProfileBillingAddress}
                                                        />
                                                    )}
                                                {paymentMethodDto?.isPaymentProfile &&
                                                    paymentMethodDto.isPaymentProfileExpired && (
                                                        <StyledWrapper {...styles.paymentProfileExpiredErrorWrapper}>
                                                            <Typography {...styles.paymentProfileExpiredErrorText}>
                                                                {siteMessage("Checkout_PaymentProfileExpired")}
                                                            </Typography>
                                                            {savedPaymentsPageLink && (
                                                                <Link
                                                                    {...styles.paymentProfileEditCardLink}
                                                                    onClick={handleEditCardClick}
                                                                >
                                                                    {translate("Edit Card")}
                                                                </Link>
                                                            )}
                                                        </StyledWrapper>
                                                    )}
                                            </>
                                        )}
                                    </GridItem>
                                </GridItem>
                                {cart.showPoNumber && (
                                    <GridItem {...styles.poNumberGridItem}>
                                        <TextField
                                            {...styles.poNumberText}
                                            label={translate("PO Number")}
                                            placeholder={translate("PO Number")}
                                            value={poNumber}
                                            onChange={(e)=>{handlePONumberChange(e)}}
                                            required={cart.requiresPoNumber}
                                            maxLength={50}
                                            error={showFormErrors && poNumberError}
                                            data-test-selector="onePageCheckout_poNumber"
                                            ref={poNumberRef}
                                        />
                                    </GridItem>
                                )}
                                
                                
                                {enableVat && (
                                    <GridItem {...styles.vatNumberGridItem}>
                                        <TextField
                                            {...styles.vatNumberText}
                                            label={translate("VAT Number")}
                                            value={vatNumber}
                                            onChange={handleVatNumberChange}
                                            maxLength={50}
                                            data-test-selector="onePageCheckout_vatNumber"
                                        />
                                    </GridItem>
                                )}
                                {paymentMethodDto?.isPaymentProfile &&
                                    !paymentMethodDto.isPaymentProfileExpired &&
                                    !bypassCvvForSavedCards && (
                                        <GridItem {...styles.savedCards}>
                                            <SavedPaymentProfileEntry
                                                iframe={iframeName}
                                                onSecurityCodeUpdate={handleSecurityCodeChange}
                                                extendedStyles={styles.savedPaymentProfile}
                                                tokenExConfig={tokenExConfig}
                                                tokenExFrameStyleConfig={tokenExFrameStyleConfig}
                                                paymentMethodDto={paymentMethodDto}
                                                updateCardIsTokenized={setIsCardNumberTokenized}
                                                ref={savedPaymentProfile}
                                            />
                                        </GridItem>
                                    )}
                                {cart.showCreditCard && paymentMethodDto?.isCreditCard && (<>
                                    <GridItem {...styles.creditCardDetailsGridItem}>
                                        <CreditCardDetailsEntryComponent
                                            canSaveCard={paymentOptions.canStorePaymentProfile}
                                            iframe={iframeName}
                                            onSaveCardUpdate={handleSaveCardChange}
                                            onCardHolderNameUpdate={handleCardHolderNameChange}
                                            onCardNumberUpdate={handleCardNumberChange}
                                            onCardTypeUpdate={handleCardTypeChange}
                                            onExpirationMonthUpdate={handleExpirationMonthChange}
                                            onExpirationYearUpdate={handleExpirationYearChange}
                                            onSecurityCodeUpdate={handleSecurityCodeChange}
                                            availableCardTypes={paymentOptions.cardTypes ?? []}
                                            availableMonths={paymentOptions.expirationMonths ?? []}
                                            availableYears={paymentOptions.expirationYears ?? []}
                                            extendedStyles={styles.creditCardDetails}
                                            isIframeLoaded={isIframeLoaded}
                                            bankAccountLastFourDigits={bankAccountLastFourDigits}
                                            creditCardLastFourDigits={creditCardLastFourDigits}
                                            variation="onePageCheckout"
                                            tokenExConfig={tokenExConfig}
                                            onTokenExSessionExpired={handleTokenExSessionExpired}
                                            tokenExFrameStyleConfig={tokenExFrameStyleConfig}
                                            updateCardIsTokenized={setIsCardNumberTokenized}
                                            spreedlyConfig={spreedlyConfig}
                                            spreedlyFrameStyleConfig={spreedlyFrameStyleConfig}
                                            updateMaskedCardNumber={setMaskedCardNumber}
                                            ref={creditCardDetails}
                                        />
                                    </GridItem>
                                    <Typography style={{color:"gray", marginTop:"10px"}}>{siteMessage("Checkout_Card_Details_Disclamier")}</Typography>
                                    </>
                                )}

                                {cart.showECheck && paymentMethodDto?.isECheck && (
                                    <GridItem {...styles.eCheckDetailsGridItem}>
                                        <ECheckDetailsEntry
                                            iframe={useECheckTokenExGateway ? "TokenEx" : undefined}
                                            paymentMethod={paymentMethod}
                                            onAccountHolderNameChange={setAccountHolderName}
                                            onAccountNumberChange={setAccountNumber}
                                            onRoutingNumberChange={setRoutingNumber}
                                            tokenExConfig={tokenExConfig}
                                            tokenExFrameStyleConfig={tokenExFrameStyleConfig}
                                            extendedStyles={styles.eCheckDetailsEntryStyles}
                                            showFormErrors={showFormErrors}
                                            updateIsECheckTokenized={setIsECheckTokenized}
                                            updateShowFormErrors={setShowFormErrors}
                                            setAccountNumberIFrame={handleAccountNumberIFrame}
                                            ref={eCheckDetails}
                                        />
                                    </GridItem>
                                )}
                                {paymentOptions.canStorePaymentProfile && paymentMethodDto?.isCreditCard && (
                                    <GridItem {...styles.saveCardCheckboxGridItem}>
                                        <Checkbox checked={saveCard} onChange={saveCreditCardChangeHandler}>
                                            {translate("Save card information")}
                                        </Checkbox>
                                    </GridItem>
                                )}
                               
                                <GridItem {...styles.saveAndContinueButtonGridItem}>
                                    <Button
                                        {...styles.saveAndContinueButton}
                                        data-test-selector="saveAndContinueButton"
                                    >
                                        {translate("Confirm")}
                                    </Button>
                                </GridItem>
                            </GridContainer>
                        </StyledFieldSet>
                    </StyledForm>
                </GridItem>
            )}
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: connect(
        mapStateToProps,
        mapDispatchToProps,
    )(withToaster(withHistory(withTheme(OnePageCheckoutPaymentDetails)))),
    definition: {
        displayName: "New One page checkout Payment Details",
        group: "One Page Checkout",
        // allowedContexts: ["OnePageCheckoutPage"],
    },
};

export default widgetModule;